import type { MeasureArea, MeasureStep } from '../../api/workEnvironmentTypes';
import { areasByNeed } from '../WorkEnvironmentSurveyDetail/measuresView';

export type TeamMeasuresStep = 'propose' | 'review' | 'highlight' | 'closed';

const TEAM_STEP: Record<MeasureStep, TeamMeasuresStep> = {
  propose: 'propose',
  review: 'review',
  highlight: 'highlight',
  plan: 'closed',
};

/** What the team does on the page. While the leader reviews, the proposals are closed and not shown. */
export const teamMeasuresStep = (step: MeasureStep | null): TeamMeasuresStep => (step ? TEAM_STEP[step] : 'closed');

/**
 * The areas that need measures stay open and the others fold away, so the person
 * reaches what matters first. With nothing that needs measures, folding would hide everything.
 */
export const proposalAreaSections = (areas: MeasureArea[]) => {
  const { needing, others } = areasByNeed(areas);
  return {
    needing,
    others,
    foldsOthers: needing.length > 0 && others.length > 0,
    firstKey: (needing[0] ?? others[0])?.key,
  };
};

type OthersState = { expanded: boolean; chosenKey: string; hasErrors: boolean };

/** Errors point to the fields under the chosen area, so its group cannot stay folded */
export const othersOpen = (others: MeasureArea[], { expanded, chosenKey, hasErrors }: OthersState) =>
  expanded || (hasErrors && others.some((area) => area.key === chosenKey));

/** How many proposals this person has sent for the area since they opened the page */
export const sentCount = (sentAreaKeys: string[], areaKey: string) =>
  sentAreaKeys.filter((key) => key === areaKey).length;
